import { Wording } from '@/types';

export const YOGA_WORDING_DE: Wording = {
  components_header_media_content: 'Trainingseinheiten',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Rezepte',
  components_header_text2: 'Blog',
  components_header_members: 'Mitglieder',
  hero_text: 'Halten Sie Ihren Körper flexibel und stark',
  hero_button_text: 'Beginnen Sie Ihre Yoga-Reise',
  components_ressources_section_title: 'RESSOURCEN',
  components_ressources_subheader_text:
    'Alle Ressourcen, die Sie für einen harmonischen Lebensstil benötigen',
  components_ressources_span_text:
    'Entdecken Sie die Geheimnisse des Wohlbefindens: Tauchen Sie ein in eine Sammlung von Yoga-Posen, achtsamen Meditationen und gesunden Rezepten, um in jedem Aspekt Ihres Lebens Ausgeglichenheit zu schaffen.',
  components_ressources_card_1_title: 'Yoga-Tipps',
  components_ressources_card_1_text:
    'Praktische Ratschläge, um Ihre Übungen zu vertiefen und Ihre Posen zu perfektionieren.',
  components_ressources_card_2_title: 'Diät',
  components_ressources_card_2_text:
    'Intelligente Ernährungstipps für ein gesünderes und stärkeres Leben.',
  components_ressources_link: 'Videos ansehen',
  components_notes_and_google_title_1: 'Yoga-Workouts',
  components_notes_and_google_title_2: 'Regelmäßige Routine',
  components_notes_and_google_title_3: 'Diäterhaltung',
  components_review_google_text: 'Rezension auf Google',
  media_content_section_title: 'TRAINING',
  media_content_section_subheader_text: 'Unsere Videos',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Weitere Videos',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Artikel und Neuigkeiten',
  text2_section_button_more: 'Weitere Artikel',
  components_text1_section_title: 'REZEPTE',
  components_text1_subheader_text: 'Nähren Sie Ihren Körper und Geist',
  components_text1_span_text:
    'Gesunde Rezepte zur Unterstützung Ihrer Yogapraxis und zur Steigerung Ihres Wohlbefindens.',
  components_text1_card_1_title: 'Energiespendende Frühstücke',
  components_text1_card_1_text:
    'Wachen Sie mit lebendigen, energiespendenden Mahlzeiten auf.',
  components_text1_card_3_title: 'Kraftvolle Mittagessen',
  components_text1_card_3_text:
    'Entdecken Sie köstliche und praktische Mittagsrezepte, die auf Ihren aktiven Lebensstil zugeschnitten sind. Von bunten Salaten bis hin zu proteinreichen Wraps – diese Rezepte halten Sie fit und konzentriert.',
  components_text1_card_2_title: 'Abendessen zur Erholung',
  components_text1_card_2_text:
    'Entdecken Sie eine Vielfalt an magerem Eiweiß, Vollkornprodukten und kräftigem Gemüse für einen zufriedenstellenden Abschluss Ihres Tages.',
  components_text1_link: 'Alle Rezepte ansehen',
  components_footer_text:
    'Finden Sie Balance, atmen Sie tief durch: Ihr Yoga, Ihre Reise.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registrierungsnummer',
  components_footer_legal: 'Legal',
  components_footer_terms: 'Geschäftsbedingungen',
  components_footer_privacy: 'Datenschutzrichtlinie',
  button_load_more: 'Mehr laden',
  page_media_1_content_hero_text: 'Yoga-Workouts',
  page_text1_hero_text: 'Rezepte',
  page_text1_section_title: 'Ernährung',
  page_text1_subheader_text: 'Rezepte',
  page_text2_hero_text: 'Unser Blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Artikel und Neuigkeiten',
  enter_email_title: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um fortzufahren',
  enter_email_placeholder_email: 'E-Mail',
  enter_email_button_enter: 'Eingeben',
  components_login_success_text: 'Anmeldung erfolgreich!',
  components_card_link_media_content: 'Jetzt ansehen',
  components_card_link_text1_content: 'Rezept ansehen',
  components_card_link_text2_content: 'Artikel ansehen',
  france: 'Frankreich',
  cyprus: 'Zypern',
};
